import { createClient, type SanityClient } from '@sanity/client';

// Sanity configuration for blog content
// These env vars need to be added to .env:
// REACT_APP_SANITY_PROJECT_ID=your-project-id
// REACT_APP_SANITY_DATASET=production

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || 'placeholder';
const dataset = process.env.REACT_APP_SANITY_DATASET || 'production';

// Cast to SanityClient to avoid complex conditional type issues with @sanity/client v7
export const sanityClient = createClient({
  projectId,
  dataset,
  apiVersion: '2024-03-19',
  useCdn: true,
});

// Helper function for fetching with proper types
export async function sanityFetch<T>(query: string, params?: Record<string, unknown>): Promise<T> {
  return (sanityClient as any).fetch(query, params || {}) as Promise<T>;
}

